import type { UserActor } from "@corpuscomplete/core/actor";
import type { ExpressionBuilder, Transaction } from "@rocicorp/zero";

import { AccessGrant } from "../grant";
import type { Scope } from "../scope";
import { zql, type Schema } from "../../zero/schema";

export namespace SpaceScopePolicy {
  const viewCriteria = AccessGrant.criteria("space", "contents", ["editor", "viewer"]);
  const writeCriteria = AccessGrant.criteria("space", "contents", ["editor"]);

  export function viewable(eb: ExpressionBuilder<"space", Schema>, actor: UserActor) {
    return eb.and(
      eb.cmp("timeArchived", "IS", null),
      eb.exists(
        "group",
        (group) =>
          group.whereExists("grants", (grant) => AccessGrant.matching(grant, actor, viewCriteria), {
            flip: true,
          }),
        { flip: true },
      ),
    );
  }

  export function editable(eb: ExpressionBuilder<"space", Schema>, actor: UserActor) {
    return eb.and(
      eb.cmp("timeArchived", "IS", null),
      eb.exists(
        "group",
        (group) =>
          group.whereExists(
            "grants",
            (grant) => AccessGrant.matching(grant, actor, writeCriteria),
            {
              flip: true,
            },
          ),
        { flip: true },
      ),
    );
  }

  export async function canWrite(
    tx: Transaction,
    actor: UserActor,
    scope: Scope.Info<"space">,
  ): Promise<boolean> {
    const space = await tx.run(zql.space.where("id", "=", scope.groupId).one());
    if (!space) {
      throw new Error("Space not found for scope");
    }
    if (space.timeArchived) {
      return false;
    }
    return AccessGrant.check(tx, actor, writeCriteria, scope.groupId);
  }
}
